import { IntervalType, TemplateVersion } from '@apps/rept/rept.constants';

import { SelectOption9 } from '@ui/components/form9/common';

import { Value } from '../../models/value';
import { TemplateApi } from '../../api/models';
import { ScheduleDescription } from './schedule-description';

export class Template
{
    public applicationName: string;
    public apiName: string;
    public description: string;
    public canBeContractual: boolean;
    public isPublic: boolean;
    public preferedPeriodicity: number;
    public templateId: string;
    public templateName: string;
    public reportIntervals: ReportInterval[];
    public version: TemplateVersion;
    public contractualSchedule: ScheduleDescription;
    public displayInPortal: boolean;
}

export class DomainTemplate extends Template
{
    private _intervalTypeNames: string[] = null;
    get intervalTypeNames (): string[]
    {
        if (this._intervalTypeNames === null)
        {
            this._intervalTypeNames = Object.keys(IntervalType)
                .map((key: string) =>
                    ({ id: parseInt(IntervalType[key], 10), name: key })
                )
                .filter((result: { id: any, name: string }): boolean =>
                    !isNaN(result.id)
                )
                .map((result: { id: any, name: string; }): string =>
                    `REPORT.PARAMETERS.ANALYSIS.${result.name}`
                );
        }

        return this._intervalTypeNames;
    }
    set intervalTypeNames (value)
    {
        this._intervalTypeNames = value;
    }
    public static mapperFromApi (source: TemplateApi): Template
    {
        const target = new Template();

        Object.assign(target, source);
        delete target['contractualSchedule'];

        target.templateId = source.templateId.toLowerCase();
        if (source.contractualSchedule !== null)
        {
            target.contractualSchedule = ScheduleDescription.mapperFromApi(source.contractualSchedule);
        }

        return target;
    }

    private getReportInterval = (periodicity: number): ReportInterval =>
        this.reportIntervals
            .find((ri: ReportInterval): boolean =>
                ri.periodicity === periodicity
            );

    public getIntervalTypes (periodicity: number): {intervalTypes: SelectOption9[], reportInterval: ReportInterval}
    {
        const xyz = [];
        const reportInterval = this.getReportInterval(periodicity);

        if (reportInterval.predefIntervals)
        {
            xyz.push(new SelectOption9(IntervalType.PREDEF, this.intervalTypeNames[IntervalType.PREDEF]));
        }

        if (reportInterval.customInterval)
        {
            xyz.push(new SelectOption9(IntervalType.CUSTOM, this.intervalTypeNames[IntervalType.CUSTOM]));
        }

        return { intervalTypes: xyz, reportInterval };
    }
}

export class ReportInterval
{
    public customInterval: CustomInterval;
    public periodicity: number;
    public predefIntervals?: Value[] | null;
}

export class CustomInterval
{
    public lowerIntervalLimit: string;
    public preferedTick: number;
    public ticks?: string[] | null;
    public upperIntervalLimit: string;
    public ticksForCompute?: string[] | null;
}
